"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('wifi', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 11.000000)"
  }, _react.default.createElement("path", {
    d: "M7.10542736e-15,7.96525873 C0.58880873,7.40725606 1.19522976,6.87857136 1.81741237,6.37920464 C13.0370976,-2.62576827 29.3821512,-2.09708357 40.0000126,7.96525873",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M34,14.7989899 C26.2680135,7.06700338 13.7319865,7.06700338 6,14.7989899",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M28,21.3137085 C23.581722,16.8954305 16.418278,16.8954305 12,21.3137085",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("circle", {
    fill: props.outStrokeColor,
    cx: "20",
    cy: "26.5",
    r: "2.5"
  }))));
});

exports.default = _default;